import React, { useCallback, useRef, useState } from 'react';
import './news-subscription-form.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import messages from '../Footer.messages';
import Modal from './modal';

const NewsSubscriptionForm = ({ className, intl }) => {
  const [email, setEmail] = useState();
  const onEmailInputChange = (e) => {
    setEmail(e.target.value);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const modalMessage = useRef('');
  const onModalHide = () => setIsModalVisible(false);
  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('email', email);
    const errorMessage = intl.formatMessage(messages['footer.news.messages.error']);
    try {
      const response = await fetch(getConfig().NEWS_SUBSCRIPTION_URL, {
        method: 'POST',
        body: formData,
      });

      const {
        status, sent_date: sentDate,
        sent_time: sentTime,
        new_date: newDate,
        new_time: newTime,
      } = await response.json();

      switch (status) {
        case 0:
          modalMessage.current = intl.formatMessage(messages['footer.news.messages.confirmation']);
          break;
        case 1:
          modalMessage.current = intl.formatMessage(messages['footer.news.messages.subscription']);
          break;
        case 2:
          modalMessage.current = intl.formatMessage(messages['footer.news.messages.activation'], {
            sentDate, sentTime, newDate, newTime,
          });
          break;
        case 3:
          modalMessage.current = intl.formatMessage(messages['footer.news.messages.emailError']);
          break;
        default:
          modalMessage.current = errorMessage;
      }
    } catch (evt) {
      modalMessage.current = errorMessage;
    }
    setIsModalVisible(true);
  }, [email]);

  return (
    <form className={classNames('news-subscription-form', className)} onSubmit={onSubmit}>
      <h5 className="news-subscription-form__header">{intl.formatMessage(messages['footer.news.labels.subscribeLine1'])}
        <br />
        {intl.formatMessage(messages['footer.news.labels.subscribeLine2'])}
      </h5>
      <div className="news-subscription-form__input-with-btn">
        <input className="news-subscription-form__email-input" placeholder={intl.formatMessage(messages['footer.news.labels.placeholder'])} type="email" name="email" value={email} onChange={onEmailInputChange} />
        <button className="news-subscription-form__submit-btn" type="submit">{intl.formatMessage(messages['footer.news.labels.subscribe'])}</button>
      </div>
      <Modal isVisible={isModalVisible} onHide={onModalHide}>
        <p className="news-subscription-form__modal-message">{modalMessage.current}</p>
      </Modal>
    </form>
  );
};

NewsSubscriptionForm.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
};

NewsSubscriptionForm.defaultProps = {
  className: undefined,
};

export default injectIntl(NewsSubscriptionForm);
